import { getCustomerID } from '@src/utils/getCustomerID';
import { AxiosRequestConfig } from 'axios';
import { get } from 'lodash';
import LRU from 'lru-cache';

const cacheConfig = {
  max: 500, // cache 500 responses. response size can be as large as 50kB. Total cached objects will be like 25MB.
  maxAge: 15 * 60 * 1000 // cache 15 min
}
const logger = console;

const pathsToBeCached = [
  `${BUILD_VARS.QUERY_DOMAIN}/v1.0/metrics`,
  `${BUILD_VARS.QUERY_DOMAIN}/v1.0/metrics/timeline`,
  `${BUILD_VARS.QUERY_DOMAIN}/v1.0/metrics/distribution`,
  `${BUILD_VARS.QUERY_DOMAIN}/v1.0/metrics/scan`,
  `${BUILD_VARS.QUERY_DOMAIN}/v1.0/ai-alerts/diagnostics`,
];

export interface IConfig {
  // if set to true, cache will be skipped
  skip: boolean;
  // request path that cache is enabled
  path: string[];
  // function to generate key for the cache
  key: (req: AxiosRequestConfig) => string;
  // function to log debug info
  debug: (...args: any[]) => void;
  // lru cache
  cache: typeof LRU;
}

const debugMode = false;

const requestKey = (req, customerId) => {
  if (req.method === 'get') {
    const paramData = JSON.stringify(req.params);
    return `${customerId}-${paramData}`;
  }
  return `${customerId}-${req.data}`
}

const cache  = new LRU(cacheConfig);

export const clearCache = () => {
  cache.reset();
}


export const config: IConfig = {
  skip: false,
  debug: (...args) => {
    if (debugMode) {
      logger.log('[cache adapter]', ...args)
    }
  },
  path: pathsToBeCached,
  key: (req) => {
    // TODO: customer id is empty for the initial requests
    // we should have an alternate axios instance without caching
    const customerId = getCustomerID();
    return requestKey(req, customerId);
  },
  cache,
};
